import { ProductionStatusBase } from './base/production-status-base';

export class ProductionStatus extends ProductionStatusBase { }